import React, { Component } from 'react';
import { withRouter } from 'react-router';
import axios from 'axios';
import { compose } from 'recompose';
import _ from 'lodash';
import moment from 'moment';
import { isEmail } from 'validator';
import { Button, Modal, Icon, Header, Divider } from 'semantic-ui-react';

import PublicHeader from '../../components/public-header';
import CreatorNewCard from '../../components/creator-new-card';
import hasRESTClient from '../../hocs/has-rest-client';
import ThemeSelector from '../../themes/theme-selector';

const currentTheme = ThemeSelector.theme();
const MOI_ID = 'efcb872a-50d9-417c-b6a5-ba427dba4c84';

const INF_DATA_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer';
const INF_CREATE_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/flyt/influencer';

const modalStyle = {
  textAlign: 'center',
  color: '#777',
};

const nameStyle = {
  marginTop: 10,
  marginBottom: 10,
  display: 'block',
};


class CreatorNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isError: false,
      influencer: null,
      instagramLoading: false,
      thumbnail: null,
      primarySocialHandle: null,
      displayName: null,
      email: null,
      emailerror: null,
      instagramLoaded: false,
      isFormSubmitted: false,
      organisationId: null,
      openModal: false,
    };
  }

  handleSocialChange = (e, v) => {
    this.setState({ instagramLoading: true, primarySocialHandle: null, thumbnail: null });
    const value = _.replace(_.get(v, 'value'), /\s/g, '');
    this.setState({ [v.name]: value });
    const handle = value;

    const payload = { data: { platform: 'instagram', name: handle } };

    const start = moment();
    return axios.post(INF_DATA_API, payload).then(r => {
      const end = moment();
      const loadTime = end.diff(start);

      const foundCreator = r.data.body.data;

      console.log(loadTime);
      console.log(foundCreator);
      console.log('organisationId', currentTheme.organisationId);

      this.setState({
        primarySocialHandle: foundCreator.username,
        instagramLoading: false,
        thumbnail: foundCreator.thumbnail,
        displayName: foundCreator.full_name,
        name: foundCreator.full_name,
        foundCreator,
        instagramLoaded: true,
        organisationId: currentTheme.organisationId,
      });
    });
  };

  getIsValid = (name, value) => {
    if (name === 'country') return value.length && value.length === 2;
    if (name === 'name') return value.length && value.length > 3;
    if (name === 'email') return value.length && isEmail(value);
    return false;
  }

  handleInputChange = (e, { name, value }) => {
    const isValid = this.getIsValid(name, value);
    this.setState({
      [name]: value,
      [`${name}Error`]: !isValid,
    });
  }

  handleEmailChanged = (e, { name, value }) => {
    console.log(value);
    const isValid = this.getIsValid(name, value);
    this.setState({
      [name]: value,
      [`${name}Error`]: !isValid,
    });
  }

  validateInput = () => {
    console.log('validating input');
    const { country, email, name } = this.state;
    console.log({ country, email, name });
    const combinedError = {};
    // check country
    if (!country) {
      _.assignIn(combinedError, { countryError: true });
    }

    if (name.length < 3) {
      _.assignIn(combinedError, { nameError: true });
    }

    if (!isEmail(email)) {
      _.assignIn(combinedError, { emailError: true });
    }

    console.log(combinedError);

    if (_.keys(combinedError).length) {
      this.setState(combinedError);
      return false;
    }
    return true;
  }

  createAccount = () => {
    if (this.validateInput()) {
      const { country, email, name, foundCreator, organisationId } = this.state;
      console.log('creating account');

      const payload = {
        data: {
          country, email, name, foundCreator, organisationId,
        },
      };

      console.log(payload);

      this.setState({
        isFormSubmitted: true,
      });

      return axios.post(INF_CREATE_API, payload)
        .then(r => {
          const { status, data: { body, statusCode } } = r;
          console.log(status);
          console.log(body);

          const { data: { influencer } } = JSON.parse(body);
          console.log(influencer);
          if (_.isEqual(statusCode, 200)) {
            if (_.isEqual(organisationId, MOI_ID)) {
              this.setState({
                openModal: true,
              });
            } else {
              this.props.history.push(`/creator/${influencer.id}`);
            }
          } else {
            this.props.history.push(`/creator/${influencer.id}`);
          }
        });
    }
    return null;
  }


  render() {
    const {
      influencer,
      isLoading,
      isError,
      instagramLoading,
      instagramLoaded,
      primarySocialHandle,
      thumbnail,
      displayName,
      name,
      nameError,
      email,
      emailError,
      country,
      countryError,
      isFormSubmitted,
      openModal,
    } = this.state;


    return (
      <div style={{ paddingTop: 10 }}>

        <PublicHeader />
        <CreatorNewCard
          isLoading={isLoading}
          instagramLoading={instagramLoading}
          instagramLoaded={instagramLoaded}
          isError={isError}
          handleSocialChange={this.handleSocialChange}
          primarySocialHandle={primarySocialHandle}
          thumbnail={thumbnail}
          displayName={displayName}
          handleInputChange={this.handleInputChange}
          handleEmailChanged={this.handleEmailChanged}
          name={name}
          nameError={nameError}
          country={country}
          countryError={countryError}
          email={email}
          emailError={emailError}
          isFormSubmitted={isFormSubmitted}
          onSubmit={this.createAccount}
          {...influencer}
        />
        <Modal
          open={openModal}
          style={modalStyle}
          size="small"
        >
          <Modal.Content>
            <Header as="h2" icon>
              <Icon name="signup" color="green" />
              <h2 style={nameStyle}>{primarySocialHandle}</h2>
              <Header.Subheader>
            The Instagram handle you have entered is already registered, please DM @moi.digital.hk on Instagram for enquiries or to verify we have the correct contact details.
                <Divider />
                <Button color="grey" onClick={() => this.setState({ openModal: false, isFormSubmitted: false })}>close</Button>
              </Header.Subheader>
            </Header>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default compose(
  withRouter,
  hasRESTClient,
)(CreatorNew);



/** WEBPACK FOOTER **
 ** ./src/containers/creator-new/index.js
 **/